export default __webpack_public_path__ + "static/media/06_DAIF_Security_02_loop.7e394584.mp4";